import { useState } from "react";
import axios from "axios";
import { Send, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const BASE_PATH = process.env.PUBLIC_URL || "";
const API = `${BACKEND_URL || BASE_PATH}/api`;

export function InquiryForm({ type = "general", title = "Start a Conversation", description, testPrefix = "inquiry" }) {
  const [form, setForm] = useState({ name: "", email: "", phone: "", organization: "", message: "" });
  const [status, setStatus] = useState("");
  const [loading, setLoading] = useState(false);

  const update = (field, value) => setForm((current) => ({ ...current, [field]: value }));

  const submit = async (event) => {
    event.preventDefault();
    setLoading(true);
    setStatus("");
    try {
      const payload = { ...form, inquiry_type: type };
      const response = await axios.post(`${API}/inquiries`, payload);
      setStatus(`Inquiry received. Reference ${response.data.id.slice(0, 8).toUpperCase()}.`);
      setForm({ name: "", email: "", phone: "", organization: "", message: "" });
    } catch (error) {
      setStatus("Something went wrong. Please try again or use WhatsApp.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form className="umeed-form" onSubmit={submit} data-testid={`${testPrefix}-form`}>
      <div className="form-heading">
        <Sparkles aria-hidden="true" />
        <div>
          <h3 data-testid={`${testPrefix}-form-title`}>{title}</h3>
          {description && <p data-testid={`${testPrefix}-form-description`}>{description}</p>}
        </div>
      </div>
      <label data-testid={`${testPrefix}-name-label`}>
        Name
        <Input value={form.name} onChange={(e) => update("name", e.target.value)} required data-testid={`${testPrefix}-name-input`} />
      </label>
      <label data-testid={`${testPrefix}-email-label`}>
        Email
        <Input type="email" value={form.email} onChange={(e) => update("email", e.target.value)} required data-testid={`${testPrefix}-email-input`} />
      </label>
      <label data-testid={`${testPrefix}-phone-label`}>
        Phone / WhatsApp
        <Input value={form.phone} onChange={(e) => update("phone", e.target.value)} required data-testid={`${testPrefix}-phone-input`} />
      </label>
      <label data-testid={`${testPrefix}-organization-label`}>
        Organisation / Occasion
        <Input value={form.organization} onChange={(e) => update("organization", e.target.value)} data-testid={`${testPrefix}-organization-input`} />
      </label>
      <label data-testid={`${testPrefix}-message-label`}>
        Message
        <Textarea value={form.message} onChange={(e) => update("message", e.target.value)} required data-testid={`${testPrefix}-message-input`} />
      </label>
      <Button className="btn-primary" type="submit" disabled={loading} data-testid={`${testPrefix}-submit-button`}>
        <Send aria-hidden="true" /> {loading ? "Sending" : "Send Inquiry"}
      </Button>
      {status && <p className="form-status" data-testid={`${testPrefix}-form-status`}>{status}</p>}
    </form>
  );
}
